import angular from 'angular';
import printSummaryModal from './printSummaryModal';

export default angular
  .module('components.printSummaryModal', [])
  .component('printSummaryModal', printSummaryModal).name;
